import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import clsx from 'clsx';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { Icon } from '../Icon/Icon';
import { pxToRem } from '../../helpers/pxToRem';
const Name = 'StarRating';
export const StarRating = ({ numberOfStars, initialRate = 0, onRateClick, displayOnly = false, className, }) => {
    const [previousRate, setPreviousRate] = useState(0);
    const [currentRate, setCurrentRate] = useState(initialRate - 1);
    const handleOnClick = (index) => {
        if (displayOnly) {
            return;
        }
        setPreviousRate(currentRate);
        setCurrentRate(index);
        //we want rating from 1 not 0
        if (onRateClick) {
            setTimeout(() => onRateClick(index + 1), (index + 1) * 100 + 100);
        }
    };
    return (_jsx(Container, { "data-component": Name, children: [...Array(numberOfStars)].map((_, index) => (_jsx(IconContainer, { className: clsx('StarRatingIconContainer', className), onClick: () => handleOnClick(index), displayOnly: displayOnly, isChecked: index <= currentRate, delayFactor: Math.abs(index - previousRate), tabIndex: displayOnly ? -1 : 0, children: _jsx(Icon, { name: "star", size: 32 }) }, `star_rate_${index}`))) }));
};
const Container = styled.div({
    display: 'flex',
    '.StarRatingIconContainer + .StarRatingIconContainer': {
        marginLeft: pxToRem(9),
    },
});
const IconContainer = styled.button(({ displayOnly, isChecked, delayFactor }) => ({
    border: 'none',
    backgroundColor: 'transparent',
    cursor: displayOnly ? undefined : 'pointer',
    svg: {
        color: isChecked ? dsColors.yellow20 : dsColors.gray05,
        transition: 'color 0.2s ease-in-out',
        transitionDelay: `${delayFactor * 50}ms`,
    },
    '&:hover': {
        svg: {
            color: isChecked ? dsColors.yellow20 : dsColors.gray20,
        },
    },
    '&:focus-visible svg': {
        boxShadow: `0px 0px 0px 4px ${dsColors.cyan20}`,
    },
}));
